import CorrectionModel from '@/dex-shared/models/CorrectionModel';
import CorrectionScoreModel from '@/dex-shared/models/CorrectionScoreModel';
import AnnotationModel from '@/dex-shared/models/AnnotationModel';
import KnowledgeModel from '@/dex-shared/models/KnowledgeModel';
import CorrectionCriteriaModel from '@/dex-shared/models/CorrectionCriteriaModel';
import ImageModel from '@/dex-shared/models/ImageModel';
import ContentModel from '@/dex-shared/models/ContentModel';

export default {
  corrections: (state: any, getters: any) => {
    return Object.values(state.corrections)
      .map((correction: any) => new CorrectionModel(correction, getters))
      .sort(
        (a: CorrectionModel, b: CorrectionModel) =>
          +b.finalizedAt - +a.finalizedAt,
      );
  },
  correctingEssays: (state: any, getters: any) => {
    return getters.essays.filter(
      (essayReply: any) => essayReply.status == 'CORRECTING',
    );
  },
  highestScoresEssays: (state: any, getters: any) => {
    return getters.corrections
      .concat() // empty concat makes sure getters.corrections is not mutated in .sort()
      .sort((a: CorrectionModel, b: CorrectionModel) => b.score - a.score)
      .slice(0, 4);
  },
  examEssays: (state: any, getters: any) => {
    return getters.corrections.filter(
      (correction: CorrectionModel) =>
        correction.essay().subject().examQuestionIds.length > 0,
    );
  },
  correctionById: (state: any, getters: any) => (correctionId: number) => {
    let correction = state.corrections[correctionId];
    if (correction) {
      return new CorrectionModel(correction, getters);
    } else {
      return {};
    }
  },
  correctionCriteriaById: (state: any, getters: any) => (
    correctionCriteriaId: number,
  ) => {
    let correctionCriteria = state.correction_criterias[correctionCriteriaId];
    if (correctionCriteria) {
      return new CorrectionCriteriaModel(correctionCriteria, getters);
    } else {
      return {};
    }
  },
  correctionScoresByCorrectionId: (state: any, getters: any) => (
    correctionId: number,
  ) => {
    return Object.values(state.correction_scores)
      .map(
        (correctionScore: any) =>
          new CorrectionScoreModel(correctionScore, getters),
      )
      .filter(
        (correctionScore: CorrectionScoreModel) =>
          correctionScore.correctionId === correctionId,
      );
  },
  correctionScoreById: (state: any, getters: any) => (
    correctionScoreId: number,
  ) => {
    let correctionScore = state.correction_scores[correctionScoreId];
    if (correctionScore) {
      return new CorrectionScoreModel(correctionScore, getters);
    } else {
      return {};
    }
  },
  annotationById: (state: any, getters: any) => (annotationId: number) => {
    let annotation = state.annotations[annotationId];
    if (annotation) {
      return new AnnotationModel(annotation, getters);
    } else {
      return {};
    }
  },
  contentsByAnnotationId: (state: any, getters: any) => (
    annotationId: number,
  ) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.annotationId === annotationId);
  },
  knowledgeById: (state: any, getters: any) => (knowledgeId: number) => {
    let knowledge = state.knowledges[knowledgeId];
    if (knowledge) {
      return new KnowledgeModel(knowledge, getters);
    } else {
      return {};
    }
  },
  imageById: (state: any, getters: any) => (imageId: number) => {
    let image = state.images[imageId];
    if (image) {
      return new ImageModel(image, getters);
    } else {
      return {};
    }
  },
};
